
import myprize from '@/assets/dice/myprize.png'
import inviteimg from '@/assets/dice/invite.png'
import prize2 from '@/assets/dice/prize2.png'
import down from '@/assets/dice/icon_down.png'
import icondice from '@/assets/dice/icon_dice.png'
import oddimg from '@/assets/dice/odd.png'
import Scratch from '@/components/scratch'
import Dice from '@/components/dice'
import Prizepath from './path'
import Box from './box'
import cjimg from '@/assets/dice/guajiangqu.png'
import { Dialog, Overlay, Toast } from 'vant'
import { getStep, addStep, getCellDetail, getRandomNum, updateZj, invitedice } from '@/api/youzheng'
import { getUserItem, award } from '@/api/lottery'
import { view, addCreditParty } from '@/api/jfhl.js'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import html2canvas from 'html2canvas'
import config from '@/config'
import { stampGet } from '@/api/jianianhua'
export default {
components: {
vanOverlay: Overlay,
Scratch,
Dice,
Prizepath,
Box,
Qrcode
},
props: {},
data () {
return {
startTime: '', // 活动开始时间
endTime: '', // 活动结束时间
showbox: false, // 显示随机方块
partyid: this.$route.params.artid, // 活动id
showscratch: false, // 显示刮奖
showmine: false, // 显示我的奖励
showinvite: false, // 显示邀请
inviteimg: inviteimg,
myprize: myprize,
oddimg: oddimg,
lottery: true,
cjimg: cjimg,
msg: '', // 刮奖后显示结果
point: '', // 投骰子点数与当前位置相加后的位置
temp: '', // 计时器
isclick: true, // 是否点击，防止连点
activeindex: 0, // 位置
activenum: 0, // 实时位置，实现前进动效
pathList: [], // 路径位置列表
cynum: '', // 剩余骰子数
curnum: '', // 当前第几次骰子
ismove: '', // 剩余移动数
isdraw: '', // 抽奖 0没有抽过奖 1已抽过奖
currstype: '', // 当前类型
prizelist: [], // 我的奖励列表
boxitem: {}, // 生成的随机方块
qrcodeUrl: '', // 二维码地址
downImgUrl: '', // 生成的分享图片
isadd: true,
ruleCode: '', // 邮票规则
stampNum: '' 
}
},
created () {

if (this.$route.query.obj) {
let temp = this.$route.query.obj.slice(0, this.$route.query.obj.length - 1)
if (temp != this.accountid) {
invitedice({
inviter: temp,
bInviter: this.accountid,
partyId: this.partyid,
oppenId: this.userid
}).then(res => {
this.$router.push({ name: 'diceactivityIndex' })
})
} else {
Dialog.alert({
message: '自己不能邀请自己哦！'
}).then(() => {
this.$router.push({ name: 'diceactivityIndex' })
})
}
}
this.getCellDetail() 
},
mounted () {
this.getview() 
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {

getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.ruleCode = res.obj.rulecode
this.stampNum = res.obj.num
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.getWinning()
this.isCurrentTime(this.startTime, this.endTime)
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var begin = new Date(beginTime)
var end = new Date(endTime)
if (currentTime < begin) {
this.$vux.alert.show({
content: '活动还未开始'
})
this.isclick = false
return false
}
if (currentTime >= end) {
this.$vux.alert.show({
content: '活动已结束'
})
this.isclick = false
return false
}
this.getstep() 
},

getWinning () {
getUserItem({
openid: this.accountid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},

getLottery () {
this.lottery = false

updateZj({
accountid: this.accountid,
partyid: this.partyid,
stepnum: this.activeindex
})

award({
openid: this.accountid,
lotid: this.lotid
}).then(data => {
if (data.obj.isaward === 1 || data.obj.isaward === 3) {
this.msg = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/ig, ''))
}
} else if (data.obj.isaward === 2) {
this.$vux.alert.show({
content: '您已经抽过奖',
onHide () {
this.showscratch = false
}
})
}
})

},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => { })
},

run (point) {

stampGet({
accountId: this.accountid,
ruleCode: this.ruleCode,
num: this.stampNum
})
if (this.isclick) { // 点击判断，只有在前进动画停止后才能再次点击骰子
this.boxitem = {}
this.isclick = false 
this.point = eval(this.point + point) 
this.addlocation(this.point, false) 
}
},

onDiceUpdate () {
this.temp = setInterval(this.plus, 500)
},

plus () {
if (this.activenum < this.point) {
this.activenum++
this.activeindex = this.activenum % 20
} else {

clearInterval(this.temp) 
this.getstep()
}
},

reduce () {
if (this.activenum > this.point) {
this.activenum--
this.activeindex = this.activenum % 20
} else {

clearInterval(this.temp) 
this.getstep()
}
},

getCellDetail () {
getCellDetail({
partyid: this.partyid
}).then(data => {
let list = []
data.obj.forEach(el => {
this.pathList[el.cellnum] = el
})


})
},

addlocation (index, isstep) {
let stepdata = this.pathList[index % 20]
console.log(this.pathList[index % 20])
this.isadd = false
addStep({
accountid: this.accountid,
partyid: this.partyid,
num: isstep ? this.curnum : this.curnum + 1,
stepnum: stepdata.cellnum == 0 ? 20 : stepdata.cellnum,
rstype: stepdata.cellnum == 0 ? 8 : stepdata.rstype,
result: stepdata.p1
}).then(res => {
if (res.success) {
this.isadd = true
if (stepdata.rstype == 5) {
Toast('获得一次投骰子机会')
}
}
})
},

getstep () {
getStep({
accountid: this.accountid,
partyid: this.partyid
}).then(res => {
this.activeindex = this.activenum = this.point = res.obj.stepnum
this.cynum = res.obj.cynum
this.curnum = res.obj.num
this.ismove = res.obj.ismove
this.isdraw = res.obj.isdraw
this.currstype = res.obj.rstype
if (this.cynum <= 0) {
this.isclick = false
} else {
this.isclick = true
}
if (this.ismove > 0 && this.currstype == 6) {

this.point = parseInt(this.point) - parseInt(this.ismove)
this.addlocation(this.point, true)
this.isclick = false
this.temp = setInterval(this.reduce, 500)
} else if (this.ismove > 0 && this.currstype == 1) {

this.point = parseInt(this.point) + parseInt(this.ismove)
this.addlocation(this.point, true)
this.isclick = false
this.temp = setInterval(this.plus, 500)
} else if (this.currstype == 2 && this.isadd) {
this.isclick = false

getRandomNum({
accountid: this.accountid,
partyid: this.partyid
}).then(data => {
let ranitem = data.obj
if (ranitem.rnum == 1) {

this.boxitem.isimage = false
this.boxitem.top = '前进'
this.boxitem.num = ranitem.move
this.boxitem.bottom = '格'
this.point = this.activeindex + ranitem.move
this.addlocation(this.point, true)
let _this = this
this.showbox = true 
setTimeout(function () {
_this.showbox = false
_this.temp = setInterval(_this.plus, 500)
}, 2000)
} else if (ranitem.rnum == 3) {

this.boxitem.isimage = true
this.boxitem.image = down
let _this = this
this.showbox = true
setTimeout(function () {
_this.showbox = false
_this.getstep()
}, 2000)
} else if (ranitem.rnum == 4) {

this.boxitem.isimage = true
this.boxitem.image = prize2
let _this = this
this.showbox = true
setTimeout(function () {
_this.showbox = false
_this.showscratch = true
}, 2000)
} else if (ranitem.rnum == 5) {

this.boxitem.isimage = true
this.boxitem.image = icondice
Toast('获得' + ranitem.dicenum + '次投骰子机会')
let _this = this
this.showbox = true 
setTimeout(function () {
_this.showbox = false
_this.getstep()
}, 2000)
} else if (ranitem.rnum == 6) {

this.boxitem.isimage = false
this.boxitem.top = '倒退'
this.boxitem.num = ranitem.move
this.boxitem.bottom = '格'
this.point = this.activeindex - ranitem.move
this.addlocation(this.point, true)
let _this = this
this.showbox = true 
setTimeout(function () {
_this.showbox = false
_this.temp = setInterval(_this.reduce, 500)
}, 2000)
} else if (ranitem.rnum == 7) {

this.boxitem.isimage = false
this.boxitem.top = '停留'
this.boxitem.num = ranitem.dicenum
this.boxitem.bottom = '次'
let _this = this
this.showbox = true 
setTimeout(function () {
_this.showbox = false
_this.getstep()
}, 2000)



}
})
} else if (this.currstype == 4 && this.isdraw == 0) {

this.showscratch = true
} else if (this.currstype == 7) {

if (this.cynum > 0) {

}
}
})
},

close () {
if (!this.lottery) {
this.showscratch = false
location.reload() 
}
},

popinvite () {
this.showinvite = true
this.share()
},

share () {
this.qrcodeUrl =
'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
config.appid +
'&redirect_uri=' +
window.location.origin + '/youzheng/wechat/youzheng/diceactivity/index/' + this.partyid +
'?obj=' + this.accountid +
'/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
setTimeout(() => {
this.shareImg()
}, 500)
},

shareImg () {
html2canvas(this.$refs.invitecard, {
width: this.$refs.invitecard.clientWidth, // dom 原始宽度
height: this.$refs.invitecard.clientHeight,
scrollY: 0,
scrollX: 0,
useCORS: true
}).then(canvas => {
let dataURL = canvas.toDataURL('image/jpg')
this.downImgUrl = dataURL
})
}
}
}
